import { FieldReadFunction } from '@apollo/client';

export const tagByIdRead: FieldReadFunction = (_, { args, toReference }) => {
	return toReference({
		__typename: 'Tag',
		id: args.id
	});
};
